import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
  Text,
} from "@fluentui/react-components";
import React, { useState } from "react";
import ReactCrop, { Crop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { v4 as uuidv4 } from "uuid";
import { IMenuItemImage } from "./AddItemForm";
import getCroppedImage from "./CropHelper";

type ImageCropFormProps = {
  tempImage: IMenuItemImage | null;
  setCropImage: React.Dispatch<React.SetStateAction<IMenuItemImage | undefined>>;
  setCropComplete: () => void;
  onCancel: () => void;
  isModalOpen: boolean;
  closeModal: () => void;
};

export function ImageCropForm({
  tempImage,
  setCropImage,
  setCropComplete,
  onCancel,
  isModalOpen,
  closeModal,
}: ImageCropFormProps) {
  const [crop, setCrop] = useState<Crop>({
    unit: "px",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  });
  const [cropping, setCropping] = useState(false);

  const handleSubmit = async () => {
    if (!tempImage?.imagePreviewUrl) return;

    try {
      setCropping(true);

      const img = document.createElement("img");
      img.src = tempImage.imagePreviewUrl;
      await img.decode();

      const croppedFile = await getCroppedImage(img, crop, `${uuidv4()}.jpeg`);

      setCropImage({
        file: croppedFile,
        imagePreviewUrl: URL.createObjectURL(croppedFile),
      });

      setCropComplete();
      closeModal();
    } finally {
      setCropping(false);
    }
  };

  const handleCancel = () => {
    if (cropping) return;
    onCancel();
    closeModal();
  };

  return (
    <Dialog open={isModalOpen} modalType="modal">
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Crop Image</DialogTitle>

          <DialogContent style={{ maxHeight: "60vh", overflowY: "auto" }}>
            {tempImage?.imagePreviewUrl ? (
              <>
                <div style={{ maxHeight: 400 }}>
                  <ReactCrop src={tempImage.imagePreviewUrl} crop={crop} onChange={(c) => setCrop(c)} />
                </div>
                <Text>
                  {Math.floor(crop.width)}px by {Math.floor(crop.height)}px
                </Text>
              </>
            ) : (
              <Text>No image selected</Text>
            )}

            {cropping && <Spinner />}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleSubmit} disabled={cropping || !tempImage} data-testid="cropSubmit">
              Submit
            </Button>

            <Button onClick={handleCancel} disabled={cropping}>
              Cancel
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
